<template>
    <q-page>
      <!-- 1 -->
      <section id="sec01" class="active">
        <article>
          <div class="container">
            <div class="imgBox">
              <img v-if="isMobile" class="imgBox_mobile" id="img1_mobile" src="../images/img1_mobile.png">
              <img v-else class="full-width img1" src="../images/img1.png">
              <!-- <img v-else class="full-width img1" src="../images/img1.png"> -->
              <div v-if="!isMobile" class="idpw_box">
                <img class="idpw" src="../images/idpw.png" alt="">
              </div>
              <div v-if="!isMobile" class="pw_box">
                <img class="pw pw1" src="../images/pw.png" alt="">
                <img class="pw pw2" src="../images/pw.png" alt="">
                <img class="pw pw3" src="../images/pw.png" alt="">
                <img class="pw pw4" src="../images/pw.png" alt="">
                <img class="pw pw5" src="../images/pw.png" alt="">
                <img class="pw pw6" src="../images/pw.png" alt="">
              </div>
              <div v-if="!isMobile" class="faceid_box">
                <img class="faceid" src="../images/faceid.png" alt="">   
              </div>
              <div v-if="!isMobile" class="fp1_box">
                <svg class="fp1" width="11%" height="5">
                  <circle v-for="n in 30" :key="n"
                    :cx="4+6*(n-1)" cy="3" r="1" fill="rgb(48,118,255)" stroke="rgb(48,118,255)"
                    :style="'animation-duration:' + (3 + 0.05*n) + 's'"
                    />
                </svg>
              </div>
              <div v-if="!isMobile" class="fp2_box">
                <img class="fp2" src="../images/fp2.png" alt="">  
              </div>
              <div v-if="!isMobile" class="loading_box">
                <img class="loading" src="../images/bcircle.png" alt=""> 
                <img class="loading" src="../images/bcircle.png" alt=""> 
                <img class="loading" src="../images/bcircle.png" alt="">  
              </div>
              <div v-if="!isMobile" class="login_box">
                <img class="login" src="../images/login.png" alt="">  
              </div>
            </div>
            <div id="sec01_textBox" class="textBox">
              <p class="subTitle">{{ text[0].subTitle }}</p>
              <p v-if="isMobile && !isTablet" class="title" id="sec01_title" v-html="text[0].title.mobile"></p>
              <p v-else class="title" id="sec01_title" v-html="text[0].title.pc"></p>
              <p v-show="!isMobile" class="sec01_content content" id="content_1" v-html="text[0].content.pc"></p> 
              <p v-show="isMobile"  class="sec01_content content" v-html="text[0].content.mobile"></p>    
            </div>
          </div>
          <div v-if="!isMobile" class="arrow bounce">
            <div @click="moveDown()">
              <img class="arrow_color" src="../images/arrow.png" alt="">
            </div>
          </div>
        </article>
      </section>
  
      <!-- 2 -->
      <section id="sec02" :class="{'active': active.sec02}">
        <article>
          <div v-show="isMobile" class="textBox">
            <p class="subTitle" id="subTitle_2" v-html="text[1].subTitle.mobile"></p>
            <p class="title">{{ text[1].title }}</p>
          </div>
          <div class="imgBox_container">
            <div class="imgBox">
              <img v-if="isMobile" class="imgBox_mobile" id="img2_mobile" src="../images/img2_mobile.png">
              <img v-else class="img2" src="../images/img2.png">
            </div>
          </div>
          <p v-show="isMobile" class="content" id="content_2">{{ text[1].content }}</p>
          <div v-show="!isMobile" class="textBox flex justify-between">
            <p class="title">{{ text[1].title }}</p>
            <div class="text_container">
              <p class="subTitle" id="subTitle_2" v-html="text[1].subTitle.pc"></p>
              <p class="content" id="content_2">{{ text[1].content }}</p>
            </div>
          </div>
        </article>
      </section>
      <!-- 3 -->
      <section id="sec03" :class="{'active': active.sec03}">
        <article>
          <div v-show="isMobile" class="textBox"> 
            <p class="subTitle" v-html="text[2].subTitle.mobile"></p>
            <p class="title">{{ text[2].title }}</p>
          </div>
          <div class="imgBox">
            <img v-if="isMobile" class="imgBox_mobile" id="img03_mobile" src="../images/img03_mobile.png">
            <img v-else class="img03" src="../images/img_03.png">
          </div>
          <p v-show="isMobile" class="content mobile" v-html="text[2].content.mobile"></p>
          <div v-show="!isMobile" class="textBox"> 
            <p class="subTitle" v-html="text[2].subTitle.pc"></p>
            <div class="row">
              <p class="title">{{ text[2].title }}</p>
              <p v-show="!isMobile" class="content desktop" v-html="text[2].content.pc"></p>
              <p v-show="isMobile" class="content mobile" v-html="text[2].content.mobile"></p>
            </div>
          </div>
        </article>
      </section>
      <!-- 4 -->
      <section id="sec04" :class="{'active': active.sec04}">
        <article>
          <div class="imgBox">
            <img v-if="isMobile" class="imgBox_mobile" id="img3_mobile" src="../images/img3_mobile.png">
            <img v-else class="img3" src="../images/img3.png">
          </div>
          <div class="textBox">
            <p class="title">{{ text[3].title }}</p>
            <p v-html="text[3].content" class="content"></p>
          </div>
        </article>
   
      </section>
      <!-- 5 -->
      <section id="sec05" :class="{'active': active.sec05}">
        <article>
          <div class="textBox">
            <p class="subTitle">{{text[4].subTitle}}</p>
            <p class="title">{{text[4].title}}</p>
            <p v-show="!isMobile" v-html="text[4].content" class="content"></p>
          </div>
          <div class="imgBox">
            <img v-if="isMobile" class="imgBox_mobile" id="img4_mobile" src="../images/img4_mobile.png">
            <img v-else class="full-width img4" src="../images/img4.png">
          </div>
          <p v-show="isMobile" v-html="text[4].content" class="content"></p>
        </article>
      </section>
      <!-- 6 -->
      <section id="sec06" :class="{'active': active.sec06}">
        <article>
          <div class="textBox text-center">
            <p class="title" v-html="text[5].title"></p>
            <nextButton class="blueBtn" btnName="체험하기" color="blue" @click.native="$router.push('/exercise')" />
          </div>  
          <div v-show="!isMobile" id="wave" >
            <svg height="240" width="880">
              <path class="path wave" 
                  stroke="rgb(48,118,255)" fill="none" stroke-width="2" 
                  stroke-linecap="round" />
            </svg>
          </div>
          <appDownload v-show="!isMobile"/>
        </article>
      </section>
      <!-- 7-->
      <section id="sec07" :class="{'active': active.sec07}" >
        <article>
          <div class="textBox text-center">
            <div class="imgBox">
              <img id="img6" src="../images/img6.png" alt="">
            </div>
            <p class="title">{{ text[6].title }}</p>
            <p v-html="text[6].content" class="content"></p>
              <a class="mailto" :href="'mailto:' + email">
                <nextButton class="blueBtn" id="sendBtn" btnName="SEND" color="blue"/>
              </a> 
          </div>  
        </article>
      </section>
    </q-page>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex'
  import NextButton from '../components/NextButton'
  import AppDownload from '../components/AppDownload'
  
  export default {
    name: 'home',
    components : {
      'nextButton' : NextButton,
      'appDownload' : AppDownload
    },
    props: {
      isMobile: Boolean,
      isTablet: Boolean
    },
    data() {
      return {
        scrollPosition: null,
        scrollY: null,
        offsetTop: {
          sec01: null,
          sec02: null,
          sec03: null,
          sec04: null,
          sec05: null,
          sec06: null,
          sec07: null
        },
        active: {
          sec01: false,
          sec02: false,
          sec03: false,
          sec04: false,
          sec05: false,
          sec06: false,
          sec07: false
        },
        email: 'contact@8byte.co.kr',
        text: [
          {
            title: { 
              mobile: '편리함과 안전함을 갖춘 <br> 최고의 OTP',
              pc: '편리함과 안전함을 갖춘 최고의 OTP'
            },
            titleLink: '@/images/title_1.png',
            imgLink: '../images/img1.png',
            subTitle: '설치없이 안전하고 빠르게',
            content: {
              mobile: 'SAFEOTP는 일회용 비밀번호(OTP)의 편리성과 계정 보호를 위한 강력한 수단을 제공합니다.',
              pc: 'SAFEOTP는 <b>일회용 비밀번호(OTP)의 편리성과 계정 보호를 위한 강력한 수단</b>을 제공합니다.'
            }
          },
          {
            title: 'Cloud Service',
            titleLink: '@/images/title_2.png',
            imgLink: '../images/img2.png',
            subTitle: {
              mobile: '별도의 구축없이 서비스 제공',
              pc: '별도의 구축없이 <b>서비스 제공</b>',
            },
            content: 'Cloud를 이용하여 확장성(Scalability)이 높고 안정적인 서비스를 제공합니다.'
          },
          {
            title: 'Security Service',
            titleLink: '@/images/title_3.png',
            // imgLink: '../images/img3.png',
            subTitle: {
              mobile: '전자서명 기능 제공',
              pc: '<b>전자서명 기능</b> 제공'
            },
            content: {
              mobile: '블록체인에서 사용하는 타원곡선 암호(ECC256)'
                    + '에 의한 전자서명 &amp; 암호화 기술을 사용하여'
                    + '출금동의, 자금 이체 등 금융거래에 활용할 수 있습니다.',
              pc: '블록체인에서 사용하는 타원곡선 암호(ECC256)에 의한 '
                + '전자서명 &amp; 암호화 기술을 사용하여 '
                + '출금동의, 자금 이체 등 금융거래에 활용할 수 있습니다.'
            }
          },
          { 
            title: 'Multi Service',
            titleLink: '@/images/title_4.png',
            imgLink: '../images/img3.png',
            subTitle: '',
            content: 'SAFEOTP는 APP OTP 뿐만 아니라 SMS, E-mail, Push 인증 서비스를 제공합니다.'
          },
          {
            title: 'Bio Service',
            titleLink: '@/images/title_5.png',
            imgLink: '../images/img4.png',
            subTitle: '생체정보로 서비스 이용',
            content: '휴대폰에 등록된 생체 인증으로 별도의 OTP 입력 없이 인증이 완료됩니다.'
          },
          {
            title: '편리하고 안전한 <br> <b>SAFEOTP 서비스</b>를 <br> 이용해보세요!',
            titleLink: '@/images/title_5.png',
            imgLink: '../images/img4.png',
            subTitle: 'LOREM IPSUM',
            content: ''
          },
          {
            title: '문의하세요!',
            titleLink: '@/images/title_5.png',
            imgLink: '../images/img4.png',
            subTitle: 'LOREM IPSUM',
            content: '아래 버튼을 통해 이메일을 보내주시면 담당자가 빠른 시일내에 연락드리겠습니다.'
          }
        ]
      }
    },
    created() {
      this.saveView('')
      this.savePosition('home')
      window.addEventListener('scroll', this.updateScroll)
    },
    computed: {
      ...mapState ({
        position: state => state.session.position
      })
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll)
      for(var i=1; i<8; i++) {
        this.offsetTop['sec0'+i] = document.getElementById('sec0'+i).offsetTop
      }
    },
    destroyed() {
      window.removeEventListener('scroll', this.updateScroll) 
    },
    methods: {
      ...mapActions({ 
        saveView: 'session/save_exerciseView',
        savePosition: 'session/save_position'   
      }),
      moveDown() {
        window.scrollTo(0,document.getElementById("sec02").offsetTop - 71)
      //   console.log(this.offsetTop)
      },
      updateScroll() {
        if(this.position == 'home'){ 
          if(!this.isMobile){
            for(var i=1; i<8; i++){
              if(this.offsetTop['sec0'+ i] < window.scrollY+(window.innerHeight*0.6)){
                this.active['sec0'+ i] = true       
              }
            }
          } else {
            for(var j=1; j<8; j++){
              if(this.offsetTop['sec0'+ j] < window.scrollY+(window.innerHeight*0.3)){
                this.active['sec0'+ j] = true     
              }
            }
          }
        } 
      }
    }
  }
  </script>
  
  <style scoped>
    /* 애니메이션 */
  
    @keyframes fadein{
      0%   { 
        transform: translateY(100px);
        opacity: 0;
      }
      100% {
        transform: translateY(0px);
        opacity: 1;
      }
    }
    @keyframes bounce {
      0%, 20%, 50%, 80%, 100% {
        transform: translateY(0);
      }
      40% {
        transform: translateY(-30px);
      }
      60% {
        transform: translateY(-15px);
      }
    }
    .bounce {
      -moz-animation: bounce 2s infinite;
      -webkit-animation: bounce 2s infinite;
      animation: bounce 2s infinite;
    }
    section .title, 
    section .subTitle, 
    section .subTitle-2,
    section .content,
    section .nextBtn,
    section .imgBox > img,
    section .blueBox,
    section .blueBtn
    section .inputBox,
    section button,
    #wave {
      opacity: 0;
    }
    section.active .title, 
    section.active .subTitle, 
    section.active .subTitle-2,
    section.active .content,
    section.active .nextBtn,
    section.active .blueBox,
    section.active .imgBox > img,
    section.active .blueBtn,
    section.active button,
    section.active .inputBox,
    section.active #wave {
      animation: fadein .7s ease;
      animation-fill-mode: forwards;
    }
  
    /* 모바일 */
    @media screen and (max-width: 1023.98px) {
      #sec01.active .imgBox,   
      #sec02.active .subTitle,
      #sec03.active .subTitle,
      #sec04.active .title,
      #sec05.active .subTitle,
      #sec06.active .subTitle,
      #sec07.active .imgBox {
        animation-delay: .1s!important;
      }
      #sec01.active .title,
      #sec02.active .title,
      #sec03.active .title,
      #sec04.active .content,
      #sec05.active .title,
      #sec06.active .title,
      #sec07.active .title {
        animation-delay: .2s!important;
      }
      #sec01.active .content,
      #sec02.active .content,
      #sec03.active .content,
      #sec04.active .imgBox,
      #sec05.active .content,
      #sec06.active .blueBtn,
      #sec07.active .content {
        animation-delay: .3s!important;
      }
      #sec02.active .imgBox,
      #sec05.active .imgBox,
      #sec07.active .blueBtn {
        animation-delay: .4s!important;
      }
    }
    /* PC */
    @media screen and (min-width: 1024px) {
      #sec01.active .subTitle,
      #sec02.active .title, 
      #sec02.active .subTitle,
      #sec03.active .title,
      #sec04.active .title,
      #sec05.active .title,
      #sec06.active .subTitle,
      #sec07.active .imgBox {
        animation-delay: .1s!important;
      }
      #sec01.active .title,
      #sec02.active .content,
      #sec03.active .subTitle,
      #sec04.active .content,
      #sec05.active .content,
      #sec06.active .title,
      #sec07.active .title {
        animation-delay: .2s!important;
      }
      #sec01.active .imgBox > img,
      #sec02.active .blueBox,
      #sec03.active .content,
      #sec04.active .imgBox > img,
      #sec05.active .imgBox > img,
      #sec06.active .blueBtn,
      #sec07.active .content {
        animation-delay: .3s!important;
      }
      #sec01.active .content,
      #sec02.active .imgBox > img,
      #sec06.active #wave,
      #sec07.active .blueBtn {
        animation-delay: .4s!important;
      }
    }
    /* 전체 공통 CSS */
    p {
      margin-bottom: 0;
    }
    input:focus {
      outline: 0;
    }
    p.title {
      color: rgb(48,118,255);
      font-size: 4rem;
      font-weight: 500;
    }
    p.title_black {
      color: black;
      font-size: 6rem;
      font-weight: bold;
      padding-right: 1.5rem;
      z-index: 200;
    }
    .arrow_color { 
      width: 27px;
    }
  
    /* iPhone 5/SE */
    @media screen and (max-width: 320.98px) {
      article {
        padding: 60px 1.5rem!important;
      }  
      #sec01 .imgBox img {
        width: 100%;
        max-width: 500px;
      }
      #sec01 .imgBox {
        padding: 0!important;
      }
      #sec01 .textBox {
        margin-left: 0!important;
        padding-left: 0!important;
        padding-right: 0!important;
      }
      #sec01 .textBox .subTitle {
        margin: 1rem 0!important;
      }
      #sec01 .textBox .title {
        font-size: 1.6rem!important;
      }
      #sec01 .textBox .content {
        font-size: .9rem!important;
      }
      #img1_mobile {
        max-width: 300px;
      }
      section p.title {
        font-size: 30px;
        font-weight: bold;
      }
      section p.content {
        font-size: 12px;
      }
      .arrow {
        bottom: 5%;
      }
      #sec01 article{
        padding-top: 70px;
      }
      #sec01 .textBox {
        margin-left: 10px;
      }
      #sec01_title {
        font-size: 24px!important;
      }
      .sec01_content {
        padding-top: 10px;
      }
      #sec02 .textBox,
      #sec04 .textBox {
        text-align: center;
      }
      #sec02 .textBox p {
        width: 100%;
      }
      #sec02 .imgBox {
        margin-top: 1rem;
        text-align: center;
      }
          section .imgBox img {
        width: 100%;
      }
      #img2_mobile {
        width: 100%;
      }
  
      #sec02 .content,
      #sec03 .content,
      #sec04 .content,
      #sec05 .content,
      #sec07 .content {
        margin-top: 10px!important;
        padding: 0!important;
      }
      #sec03 .textBox {
        display: flex;
        flex-wrap: wrap;
        text-align: center;
      }
      #sec03 .textBox p {
        width: 100%;
      }
      #sec04 article {
          padding-bottom: 2rem!important;
      }
      #sec05 .content {
        text-align: center;
      }
      #sec07 .imgBox img {
        width: 50px;
      }
    }
    @media screen and (min-width: 321px) and (max-width: 599.98px) {
      article {
        padding: 60px 1.5rem!important;
      }  
      section p.title {
        font-size: 40px;
        font-weight: bold;
        line-height: 47px;
      }
      section p.subTitle {
        font-size: 15px;
        font-weight: medium;
        padding-bottom: 10px;
        padding-top: 10px;
      }
      section p.content {
        font-size: 15px;
        padding-top: 10px;
        text-align: center;
      }
      #sec01 .content {
        text-align: left!important;
      }
      .imgBox_mobile {
        max-width: 580px; 
      }
      #sec01 .imgBox img {
        width: 100%;
      }
      #sec01 .imgBox {
        padding: 0!important;
      }
      #sec01 .textBox {
        margin-left: 0!important;
        padding-left: 0!important;
        padding-right: 0!important;
      }
      #sec02 {
        background: #EBF2FF;
      }
      #sec02 .imgBox {
        margin: 1 0 1rem!important;
        padding: 0 1rem!important;
      }
  
      section .imgBox {
        max-width: 550px!important;
        width: 100%;
        margin: 0 auto;
      }
      section .imgBox img {
        width: 100%;
      }
      #sec02 .textBox {
        margin-left: 10px;
      }
  
      #sec02 .content,
      #sec03 .content,
      #sec04 .content,
      #sec05 .content,
      #sec07 .content {
        margin-top: 10px!important;
        padding: 0!important;
      }
      .arrow {
        bottom: 5%;
      }
      #img6 {
        width: 90px;
        margin-bottom: 10px;
      }
      #sec06 .title {
        font-size: 35px!important;
        font-weight: bold;
      }
    }
    @media screen and (min-width: 600px) and (max-width: 768.98px) {    
      article {
        padding: 100px 3rem!important;
      }
      #sec01 .imgBox img {
        width: 100%;
      }
      #sec01 .imgBox {
        padding: 0!important;
      }
      #sec01 .textBox {
        margin-left: 0!important;
        padding-left: 0!important;
        padding-right: 0!important;
      }
      section p.title {
        font-size: 50px;
        font-weight: bold;
      }
      section p.subTitle {
        font-size: 20px;
        font-weight: medium;
        padding-bottom: 10px;
        padding-top: 10px;
      }
      section p.content {
        font-size: 20px;
        padding-top: 5px;
      }
      .imgBox_mobile {
        max-width: 580px; 
      }
  
      section .imgBox {
        max-width: 580px!important;
        width: 100%;
        margin: 0 auto;
      } 
  
      #sec01 .textBox {
        margin-left: 10px;
      }
      .sec01_content {
        padding-top: 20px;
      }
      #sec02 .textBox,
      #sec04 .textBox {
        text-align: center;
      }
      #sec02 .textBox p {
        width: 100%;
      }
      #sec02 .imgBox {
        margin-top: 1rem;
        text-align: center;
      }
      #sec02 .content,
      #sec03 .content,
      #sec04 .content,
      #sec05 .content,
      #sec07 .content {
        margin-top: 10px!important;
        padding: 0 2rem!important;
      }
      #sec03 .textBox {
        display: flex;
        flex-wrap: wrap;
      }
      #sec03 .textBox p {
        width: 100%;
      }
      #img1_mobile {
        max-width: 600px;
      }
  
      .imgBox_mobile {
        width: 500px; 
      }
      #img6 {
        width: 90px;
      }
      #sec06 .title {
        letter-spacing: -3px;
      }
      #sec07 .content {
        font-size: 1rem;
      }
    }
    @media screen and (min-width: 769px) and (max-width: 1023.98px) {
      /* SEC01 */
      /* #sec01 .textBox {
        top: 50%;
        left: 2%;
        transform: translateY(-60%);
        z-index: 100;
        width: 60%;     
      }
      #sec01 .imgBox {
        position: absolute;
        top: 50%; 
        right: 1%;
        transform: translateY(-50%);
        width: 60%;
        text-align: center;
      } */
      section p.title {
        font-size: 50px;
        font-weight: bold;
        text-align: center;
        
      }
      section p.subTitle {
        font-size: 20px;
        font-weight: medium;
        text-align: center;
        padding-bottom: 0px;
        padding-top: 10px;
      }
      section p.content {
        font-size: 20px;
        padding-top: 5px;
        text-align: center;
      }
      .imgBox_mobile {
        max-width: 580px; 
      }
      /* SEC01 */
      #img1_mobile{
        margin-top: -10px;
      }
      #img6 {
        width: 90px;
      }
      #sec06 .title {
        letter-spacing: -3px;
      }
      #sec07 .content {
        font-size: 1rem;
      }
    }
    /* 모바일 공통 */
    @media screen and (max-width: 1023.98px) {
      article {
        padding: 100px 5rem;
      }
      #sec01 .imgBox {
        padding: 0;
      }
      #sec01 .textBox {
        margin-left: 0;
        padding-left: 0;
        padding-right: 0;
      }
      #sec02 {
        background: #EBF2FF;
      }
      #sec02 .imgBox img {
        width: 100%;
      }
      #sec03 .imgBox img {
        width: 100%;
      }
      #sec04 .title {
        padding-top: 30px!important;
      }
      .arrow {
        text-align: right;
        margin: 8% 0;
        position: absolute;
        bottom: -5%;
        right: 5%;
        z-index: 100;
        width: 100%;
      }
  
      article {
        padding: 100px 0;
      }
      #sec01 {
        position: relative;
      }
  
      section .imgBox {
        padding: 0 1rem;
        text-align: center;
      }
      section .textBox {
        padding-left: 1rem;
        padding-right: 1rem;
      }
      section .subTitle {
        font-size: 16px;
      }
      section .content {
        font-size: 10px;
      }
       .subTitle { 
        color: black;
        order: 1;
      }
      .title {
        order: 2;
      }
      .content {
        order: 3;
        /* padding:0 2rem; */
      }
      #sec01 .textBox {
        margin-left: 10px;
      }
      #sec02 .textBox,
      #sec04 .textBox {
        text-align: center;
      }
      #sec02 > article {
        padding-top: 50px!important;
      }
      #sec02 .textBox p {
        width: 100%;
      }
      #sec02 .imgBox {
        margin-top: 1rem;
        text-align: center;
      }
      #sec02 .content,
      #sec03 .content,
      #sec04 .content,
      #sec05 .content,
      #sec07 .content {
        margin-top: 10px;
        padding: 0 2rem;
      }
  
      #sec03 .textBox {
        display: flex;
        flex-wrap: wrap;
      }
      #sec03 .textBox p {
        width: 100%;
      }
      #sec01 .imgBox {
        text-align: center;
        padding: 0px 20px;
        width: 100%;
        overflow: hidden;
      }
      #sec04 > article {
        padding-bottom: 0px!important;
      }
      /* SEC05 */
      #sec05 > article {
        padding-bottom: 0px!important;
      }
      #sec05 .textBox {
        padding: 0 20px;
        text-align: center;
      }
      #sec04 .content {
        margin: 10px 0;
        padding: 0 20px;
      }
      #sec05 .content {
        margin: 10px 0;
        padding: 0 20px;
      }
      /* SEC03 */ 
      #sec03 .textBox {
        text-align: center;
      }
      /* SEC06 */
      #sec06 .title {
        margin: 10px 0px 30px 0px;
      }
      #sec06 .blueBtn {
        margin: 0 auto;
      }
      #sec06 {
        margin: 100px 0px;
      }
      /* SEC07 */
      #sec07 {
        background: #EEF4FF;
      }
      #sec07 .content {
        margin: 10px 0px 30px 0px;
        padding: 0 20px;
      }
      #sec07 .mailto {
        display: inline-block;
      }
      #sec07 .blueBtn {
        margin: 0 auto;
      }
  
    } 
  
    /*  
      PC 버전 
    */
    path {
      stroke-dasharray: 3,7;
      /* animation: dash 5s linear infinite; */
    }
  
    @keyframes dash {
      to {
        stroke-dashoffset: 1000;
      }
    }
  
    /* 그리기 애니메이션 */
    /* path.draw {
      stroke-dasharray: 1000;
      stroke-dashoffset: 1000;
      animation: dash 5s linear forwards;
    }
  
    @keyframes draw {
      to {
        stroke-dashoffset: 0;
      }
    } */
    @-webkit-keyframes wave {
      0%   { 
        transform: translateY(100px);
        opacity: 0;
      }
      50% {
  
      }
      100% {
        transform: translateY(0px);
        opacity: 1;
      }
    }
    @keyframes move_wave {
      0% {
          transform: translateX(0) translateZ(0) scaleY(1)
      }
      50% {
          transform: translateX(50%) translateZ(0) scaleY(0.8)
      }
      100% {
          transform: translateX(100%) translateZ(0) scaleY(1)
      }
    }
    @keyframes path {
      0% {
        d: path('M 0 120 Q 55 80 110 60, Q 165 40 220 40, Q 275 40 330 60, Q 385 80 440 120, Q 495 160 550 180, Q 605 200 660 200, Q 715 200 770 180, Q 825 160 880 120');
      }
      12.5% {
        d: path('M 0 180 Q 55 160 110 120, Q 165 80 220 60, Q 275 40 330 40, Q 385 40 440 60, Q 495 80 550 120, Q 605 160 660 180, Q 715 200 770 200, Q 825 200 880 180');
      }
      25% {
        d: path('M 0 200 Q 55 200 110 180 Q 165 160 220 120 Q 275 80 330 60 Q 385 40 440 40 Q 495 40 550 60 Q 605 80 660 120 Q 715 160 770 180 Q 825 200 880 200');
      }
      37.5% {
        d: path('M 0 180 Q 55 200 110 200 Q 165 200 220 180 Q 275 160 330 120 Q 385 80 440 60 Q 495 40 550 40 Q 605 40 660 60 Q 715 80 770 120 Q 825 160 880 180');
      }
      50% {
        d: path('M 0 120 Q 55 160 110 180 Q 165 200 220 200 Q 275 200 330 180 Q 385 160 440 120 Q 495 80 550 60 Q 605 40 660 40 Q 715 40 770 60 Q 825 80 880 120');
      } 
      62.5% {
        d: path('M 0 60 Q 55 80 110 120 Q 165 160 220 180 Q 275 200 330 200 Q 385 200 440 180 Q 495 160 550 120 Q 605 80 660 60 Q 715 40 770 40 Q 825 40 880 60');
      }
      75% {
        d: path('M 0 40 Q 55 40 110 60 Q 165 80 220 120 Q 275 160 330 180 Q 385 200 440 200 Q 495 200 550 180 Q 605 160 660 120 Q 715 80 770 60 Q 825 40 880 40');
      }
      87.5% {
        d: path('M 0 60 Q 55 40 110 40 Q 165 40 220 60 Q 275 80 330 120 Q 385 160 440 180 Q 495 200 550 200 Q 605 200 660 180 Q 715 160 770 120 Q 825 80 880 60');
      }
      100% {
        d: path('M 0 120 Q 55 80 110 60 Q 165 40 220 40 Q 275 40 330 60 Q 385 80 440 120 Q 495 160 550 180 Q 605 200 660 200 Q 715 200 770 180 Q 825 160 880 120');
      } 
    }
     
    @media screen and (min-width: 1024px) {
      @keyframes hide_circle {
        0% { opacity: 0;}
        100% { opacity: 0;}
      }
      @keyframes fade_in {
        0% { opacity: 0; }
        89% { opacity: 0; }
        90% { opacity: 1; }
        100% { opacity: 1;}
      }
      @keyframes show_up {
        0% {
          opacity: 0;
          transform: translateY(100px);
        }
        30% {
          opacity: 1;
          transform: translateY(0px);
        }
        100% {
          opacity: 1;
          transform: translateY(0px);
        }
      }
      @keyframes hide_down {
        0% {
          opacity: 1;
          transform: translateY(0px);
        }
        40% {
          opacity: 0;
          transform: translateY(100px);
        }
        100% {
          opacity: 0;
          transform: translateY(100px);
        }
      }
      @keyframes fade_slow_in {
        0% { opacity: 0; }
        30% { opacity: 0; }
        40% { opacity: 1; }
        100% { opacity: 1; }
      }
      @keyframes show_in_out {
        0% { opacity: 0; }
        10% { opacity: 0; }
        20% { opacity: 1; }
        25% { opacity: 1; }
        35% { opacity: 0; }
        100% { opacity: 0; }
      }
      @keyframes loading_in {
        0% { opacity: 0; }
        19% { opacity: 0; }
        20% { opacity: 1;}
        100% { opacity: 1; }
      }
      @keyframes loading_out {
        0% { opacity: 0; }
        100% { opacity: 0; }
      }
      @keyframes login_noti {
        0% { opacity: 0; }
        75% { opacity: 0; }
        76% { opacity: 1; }
        100% { opacity: 1;}
      }
      img.idpw {
        animation: show_up 4s 1s, hide_down 3s 5s;
        opacity: 0;
      }
      .pw, circle {
        animation: fade_in;
      }
      img.loading {
        opacity: 0;
      }
      .loading:nth-child(1) {
        animation: loading_in 10s, loading_out 5s 7.5s;
      }
      .loading:nth-child(2) {
        animation: loading_in 11s, loading_out 5s 7.5s;
      }
      .loading:nth-child(3) {
        animation: loading_in 12s, loading_out 5s 7.5s;
      }
      .faceid, .fp2 {
        animation: fade_slow_in 12s;
      }
      .pw1 {
        animation-duration: 7s;
      }
      .pw2 {
        animation-duration: 6.8s;
      }
      .pw3 {
        animation-duration: 6.6s;
      }
      .pw4 {
        animation-duration: 6.4s;
      }
      .pw5 {
        animation-duration: 6.2s;
      }
      .pw6 {
        animation-duration: 6s;
      }
      .login {
        animation: login_noti 10s;
      }
      path.wave {
        animation: path 9s linear infinite;
      }
      section#sec01 { 
        height: 100vh;
      }
      #sec01 > article  {
        position: relative;
        height: 100%;
      } 
      #sec01 > article > .container {
        position: absolute;
        top: 50%; 
        width: 100%;
        transform: translateY(-50%);
      }
      .arrow {
        text-align: right!important;
        position: absolute;
        bottom: 100px;
        z-index: 100;
        left: 0;
        right: 100px;
      }
      #sec01 .textBox {
        width: 100%;    
        text-align: center; 
      }
      #sec01 .subTitle {
        font-size: 1.2rem;
      }
      #sec01 .title {
        font-size: 3.5rem;
        font-weight: bold;
      }
      #sec01 .content {
        font-size: 1.2rem;
        font-weight: 500;
        margin-top: 0.6rem;
      }
      #sec01 .imgBox {
        position: relative;
        width: 100%;
        padding-left: 100px;
        padding-right: 100px;
      } 
  
  
      section:not(#sec01) {
        height: 1000px;
        max-height: calc(100vh - 72px);
      }
      /* SEC02 */
      #sec02 {
        background: #EBF2FF;
      }
      #sec02 > article {
        position: relative;
        height: 100%;
      }
      #sec02 .imgBox_container {
        height: 80%;
        position: relative;
      } 
      #sec02 .imgBox {
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        text-align: center;
        width: 100%;
        height: 100%;
        display: flex!important;
            align-items: center!important;
      }
      #sec02 .imgBox img {
        /* max-width: 900px; */
        height: 80%;
        margin: 0 auto;
      }
      #sec02 .textBox {
        padding-left: 100px;
        padding-right: 100px;
      }
      #sec02 .subTitle,
      #sec02 .content {
        text-align: right
      }
  
      #sec02 .title,
      #sec02 .text_container {
        width: 50%;
      }
  
      #sec02 .title {
        font-size: 3.4rem;
        color: black;
        font-weight: 500;
      }
      #sec02 .subTitle {
        font-size: 1.5rem;
        color: black;
      }
      #sec02 .content {
        font-size: 1rem;
        margin-top: .5rem;
      }
  
      /* SEC03 */
      #sec03 > article {
        position: relative;
        height: 100%;
      }
      #sec03 .imgBox {
        position: absolute;
        top: 60%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        width: 100%;
        text-align: center;
      }
      #sec03 .imgBox img {
        max-width: 900px;
      }
      #sec03 .textBox {
        padding: 100px;
      }
      #sec03 .title {
        width: 55%;
        font-size: 4rem;
        font-weight: 500;
      }
      #sec03 .subTitle {
        color: black;
        font-size: 1.2rem;
        font-weight: bold;
      }
      #sec03 .content {
        width: 45%;
        line-height: 2.2rem;
        font-size: 1rem;
        margin-top: 1rem;
      }
  
      #sec04 {
        margin-top: 100px;
        background: #EBF2FF;
      }
      #sec04 > article {
        position: relative;
        height: 100%;
      }
      #sec04 .textBox {
        position: relative;
        z-index: 100;
        text-align: right;
        padding: 100px;
      }
      #sec04 .imgBox {
        position: absolute;
        top: 50%;
        left: 100px;
        height: 80%;
        transform: translateY(-50%);
      }
      #sec04 .imgBox img {
        height: 100%;
      }
      #sec04 .title {
        font-size: 4rem;
        font-weight: bold;
      }
      #sec04 .content {
        font-size: 1.1rem;
        margin-top: 0.7rem;
      }
  
      #sec05 > article {
        position: relative;
        height: 100%;
      }
      #sec05 .textBox {
        padding: 100px 100px 0;
        position: relative;
        z-index: 100;
      }
      #sec05 .title {
        font-size: 4rem;
        font-weight: bold;
      }
      #sec05 .subTitle {
        font-size: 1.2rem;
        color: black;
        padding-left: 5px;
      }
      #sec05 .content {
        margin-top: 0.7rem;
        font-size: 1.2rem;
        padding-left: 5px;
      }
      #sec05 .imgBox {
        position: absolute;
        top: 60%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        width: 100%;
        text-align: center;
        z-index: 50;
      }
      #sec05 .imgBox img {
        max-width: 900px;
      }
  
  
  
      /* SEC06 */
      
      #sec06 > article {
        position: relative; 
        height: 100%;
      }
      #sec06 .textBox {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        z-index: 10;
      }
      #sec06 .title {
        font-size: 3.4rem;
        line-height: 5rem;
      }
      #sec06 .subTitle {
        margin-bottom: 20px;
      }
      #wave {
        position: absolute;
        z-index: 1;
        top: 57%;
        left: 0%;
        width: 100%;
        text-align: center;
      }
      /* #wave path{
        stroke-dasharray: 3,7;
      } */
      #sec06 .blueBtn {
        position: relative;
        z-index: 1000;
      }
      #sec06 .appDownloadBox {
        position: absolute;
        bottom: 25%;
        left: 5%;
      }
      #sec06 .blueBtn {
        margin: 3rem auto;
      }
      .blueBtn{
        width: 300px!important;
        height: 60px!important;
        font-size: 17px;
        padding-left: 20px;
      }
  
  
      /* SEC07 */
      #sec07 {
        height: 600px!important;
        background-color: #E7EFFF;
      }
      #sec07 > article {
        position: relative;
        height: 100%;
      }
      #sec07 .textBox {
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        width: 100%;
        text-align: center;
      }
      #sec07 .title {
        font-size: 3.6rem;
        letter-spacing: -2px;
        font-weight: 500;
      }
      #sec07 .content {
        font-size: 0.9rem;
        margin-top: 1rem;
      }
      #sec07 .mailto {
        display: inline-block;  
        position: relative;
        z-index: 1000;
        margin-top: 3rem;
      }
      #sec07 .imgBox img {
        width: 100px;
      }
    }
    
    @media screen and (min-width: 1024px) and (max-width: 1439.98px) { 
      #sec02 .imgBox img {
        max-height: 550px!important;
      }
      .pw_box {
        position: absolute;
        top: 29%;
        width: calc(100% - 190px)
      }
      .pw {
        position: absolute;
        width: 3.2%;
      }
      .pw1 {
        right: 10%;
      }
      .pw2 {
        right: 14%;
      }
      .pw3 {
        right: 18%;
      }
      .pw4 {
        right: 22%;
      }
      .pw5 {
        right: 26%;
      }
      .pw6 {
        right: 30%;
      }
      .loading_box {
        position: absolute;
        top: 53%;
        width: calc(100% - 200px);
      }
      .loading:nth-child(1) {
        position: absolute;
        left: 53%;
        width: 1.2%;
      }
      .loading:nth-child(2) {
        position: absolute;
        left: 58%;
        width: 1.2%;
      }
      .loading:nth-child(3) {
        position: absolute;
        left: 63%;
        width: 1.2%;
      }
      .idpw_box {
        position: absolute;
        top: 21%;
        width: calc(100% - 190px);
      }
      img.idpw {
        position: absolute;
        right: 15%;
        width: 12%;
      }
      .faceid_box {
        position: absolute;
        top: 45%;
        width: calc(100% - 200px);
      }
      .faceid {
        position: absolute;
        left: 31%;
        width: 10%;
      }
      .fp1_box {
        position: absolute;
        bottom: 12.2%;
        width: calc(100% - 200px);
      }
      .fp1 {
        position: absolute;
        left: 36.5%;
      }
      .fp2_box {
        position: absolute;
        bottom: 8%;
        width: calc(100% - 200px);
      }
      .fp2 {
        position: absolute;
        bottom: 7%;
        left: 48%;
        width: 3.6%;
      }
      .login_box {
        position: absolute;
        top: 50%;
        width: calc(100% - 200px);
      }
      img.login {
        position: absolute;
        left: 52%;
        width: 13%;
      }
    }
    @media screen and (min-width: 1440px) and (max-width: 1999.98px) {
      #sec01 .imgBox {
        padding-left: 200px;
        padding-right: 200px;
      }  
      .pw_box {
        position: absolute;
        top: 29%;
        width: calc(100% - 390px)
      }
      .pw {
        position: absolute;
        width: 3.2%;
      }
      .pw1 {
        right: 10%;
      }
      .pw2 {
        right: 14%;
      }
      .pw3 {
        right: 18%;
      }
      .pw4 {
        right: 22%;
      }
      .pw5 {
        right: 26%;
      }
      .pw6 {
        right: 30%;
      }
  
      .loading_box {
        position: absolute;
        top: 53%;
        width: calc(100% - 400px);
      }
      .loading:nth-child(1) {
        position: absolute;
        left: 53%;
        width: 1.2%;
      }
      .loading:nth-child(2) {
        position: absolute;
        left: 58%;
        width: 1.2%;
      }
      .loading:nth-child(3) {
        position: absolute;
        left: 63%;
        width: 1.2%;
      }
      .idpw_box {
        position: absolute;
        top: 21%;
        width: calc(100% - 400px);
      }
      img.idpw {
        position: absolute;
        right: 15%;
        width: 12%;
      }
      .faceid_box {
        position: absolute;
        top: 45%;
        width: calc(100% - 400px);
      }
      .faceid {
        position: absolute;
        left: 31%;
        width: 10%;
      }
      .fp1_box {
        position: absolute;
        bottom: 12.2%;
        width: calc(100% - 400px);
      }
      .fp1 {
        position: absolute;
        left: 36.5%;
        width: 11%;
      }
      .fp2_box {
        position: absolute;
        bottom: 8%;
        width: calc(100% - 400px);
      }
      .fp2 {
        position: absolute;
        bottom: 7%;
        left: 48%;
        width: 3.6%;
      }
      .login_box {
        position: absolute;
        top: 50%;
        width: calc(100% - 400px);
      }
      img.login {
        position: absolute;
        left: 52%;
        width: 13%;
      }
  
      #sec02 .imgBox img {
        /* max-width: 1000px!important; */
      }
      #sec02 .textBox {
        padding-left: 200px;
        padding-right: 200px;
      }
      #sec02 .title {
        font-size: 4rem!important;
      }
      #sec02 .subTitle {
        font-size: 1.6rem;
      }
      #sec02 .content {
        font-size: 1.1rem;
        margin-top: .7rem;
      }
  
      /* SEC03 */
      #sec03 .imgBox {
        top: 70%;
      }
      #sec03 .imgBox img {
        max-width: 1000px;
      }
      #sec03 .textBox {
        padding: 100px 200px;
      }
      #sec03 .title {
        font-size: 4.4rem;
      }
      #sec03 .subTitle {
        font-size: 1.4rem;
      }
      #sec03 .content {
        font-size: 1.1rem;
        margin-top: 1.1rem;
      }
  
      #sec04 {
        margin-top: 200px;
      }
      #sec04 .textBox {
        padding: 100px 200px;
      }
      #sec04 .imgBox {
        left: 200px;
        height: 90%;
      }
      #sec04 .title {
        font-size: 4.4rem;
      }
      #sec04 .content {
        font-size: 1.1rem;
        margin-top: 0.7rem;
      }
  
  
      #sec05 .textBox {
        padding: 100px 200px;
      }
      #sec05 .title {
        font-size: 4.2rem;
      }
      #sec05 .subTitle {
        font-size: 1.4rem;
      }
      #sec05 .content {
        margin-top: 0.7rem;
        font-size: 1.3rem;
      }
      #sec05 .imgBox {
        top: 55%;
      }
      #sec05 .imgBox img {
        max-width: 1000px;
      }
  
      #sec06 .title {
        font-size: 4rem;
        line-height: 5.5rem;
      }
      
      /* SEC07 */
      #sec07 .title {
        font-size: 3.8rem;
        
      }
      #sec07 .content {
        font-size: 1rem;
      }
    }
    @media screen and (min-width: 2000px) {
      .pw_box {
        position: absolute;
        top: 29%;
        width: calc(100% - 590px)
      }
      .pw {
        position: absolute;
        width: 3.2%;
      }
      .pw1 {
        right: 10%;
      }
      .pw2 {
        right: 14%;
      }
      .pw3 {
        right: 18%;
      }
      .pw4 {
        right: 22%;
      }
      .pw5 {
        right: 26%;
      }
      .pw6 {
        right: 30%;
      }
  
      .loading_box {
        position: absolute;
        top: 53%;
        width: calc(100% - 600px);
      }
      .loading:nth-child(1) {
        position: absolute;
        left: 53%;
        width: 1.2%;
      }
      .loading:nth-child(2) {
        position: absolute;
        left: 57%;
        width: 1.2%;
      }
      .loading:nth-child(3) {
        position: absolute;
        left: 61%;
        width: 1.2%;
      }
      .idpw_box {
        position: absolute;
        top: 21%;
        width: calc(100% - 600px);
      }
      img.idpw {
        position: absolute;
        right: 15%;
        width: 12%;
      }
      .faceid_box {
        position: absolute;
        top: 45%;
        width: calc(100% - 600px);
      }
      .faceid {
        position: absolute;
        left: 31%;
        width: 10%;
      }
      .fp1_box {
        position: absolute;
        bottom: 12.2%;
        width: calc(100% - 600px);
      }
      .fp1 {
        position: absolute;
        left: 36.5%;
        width: 11%;
      }
      .fp2_box {
        position: absolute;
        bottom: 8%;
        width: calc(100% - 600px);
      }
      .fp2 {
        position: absolute;
        bottom: 7%;
        left: 48%;
        width: 3.6%;
      }
      .login_box {
        position: absolute;
        top: 50%;
        width: calc(100% - 600px);
      }
      img.login {
        position: absolute;
        left: 52%;
        width: 13%;
      }
  
      #sec01 .imgBox {
        padding-left: 300px;
        padding-right: 300px;
      }  
      #sec02 .imgBox img {
        /* max-width: 1100px!important; */
      }
      #sec02 .textBox {
        padding-left: 300px;
        padding-right: 300px;
      }
      #sec02 .title {
        font-size: 5rem!important;
      }
      #sec02 .subTitle {
        font-size: 2rem;
        margin-top: .5rem;
      }
      #sec02 .content {
        font-size: 1.2rem;
        margin-top: 1rem;
      }
  
      /* SEC03 */
      #sec03 .imgBox {
        top: 80%;
      }
      #sec03 .imgBox img {
        max-width: 1200px;
      }
      #sec03 .textBox {
        padding: 100px 300px;
      }
      #sec03 .title {
        font-size: 4.6rem;
      }
      #sec03 .subTitle {
        font-size: 1.6rem;
      }
      #sec03 .content {
        font-size: 1.2rem;
        margin-top: 1.2rem;
      }
  
      #sec04 {
        margin-top: 300px;
      }
      #sec04 .textBox {
        padding: 100px 300px;
      }
      #sec04 .imgBox {
        left: 300px;
        height: 90%;
      }
      #sec04 .title {
        font-size: 4.4rem;
      }
      #sec04 .content {
        font-size: 1.1rem;
        margin-top: 0.7rem;
      }
  
  
  
      #sec05 .textBox {
        padding: 100px 300px;
      }  
      #sec05 .title {
        font-size: 4.4rem;
      }
      #sec05 .subTitle {
        font-size: 1.5rem;
      }
      #sec05 .content {
        margin-top: 2.3rem;
        font-size: 1.4rem;
      }
      #sec05 .imgBox {
        top: 55%;
      }
      #sec05 .imgBox img {
        max-width: 1100px;
      }
  
  
      #sec06 .title {
        font-size: 4.2rem;
        line-height: 5.7rem;
      }
  
      #sec07 .title {
        font-size: 4rem; 
      }
      #sec07 .content {
        font-size: 1.1rem;
      } 
    }
  
  </style>
  
  